export const ACCOUNT_BLAZER_LINK =
  'https://blazer.instacart.tools/blazer/queries/244396-koosh-enterprise-account-lookup?enterprise_account_id=&canonical_id='
